export default __webpack_public_path__ + "static/media/SF Compact Text Regular.8b9060a5.ttf";